/** Fixed-shape transport and history icons shared by web and mobile builds. */
const icon = (children) => (
  <svg aria-hidden="true" focusable="false" width="20" height="20" viewBox="0 0 24 24"
    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    {children}
  </svg>
);

export const PlayIcon = () => icon(<path d="M7 4.5 19 12 7 19.5z" fill="currentColor" stroke="none" />);
export const PauseIcon = () => icon(<>
  <path d="M8 5v14" strokeWidth="3" />
  <path d="M16 5v14" strokeWidth="3" />
</>);
export const NextBranchIcon = () => icon(<>
  <path d="M4 4.5 16 12 4 19.5z" fill="currentColor" stroke="none" />
  <path d="M20 4v16" />
</>);
export const UndoIcon = () => icon(<>
  <path d="m9 6-5 5 5 5" />
  <path d="M4 11h9a7 7 0 0 1 7 7v1" />
</>);
export const RedoIcon = () => icon(<>
  <path d="m15 6 5 5-5 5" />
  <path d="M20 11h-9a7 7 0 0 0-7 7v1" />
</>);
export const CloseIcon = () => icon(<path d="M6 6l12 12M18 6 6 18" />);
